import ButtonCst from "@components/ButtonCst";
import { FilterListOff, FilterListOutlined } from "@mui/icons-material";
import {
  Box,
  Collapse,
  Grid,
  Pagination,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@context/auth";
import LibraryFilterBox from "@components/LibraryListBoxCst/components/LibraryFilterBox";
import MyClassCardCst from "@components/MyClassCardCst";
import { useFilters } from "@context/filters";

const MyClassListBoxCst: React.FC<any> = ({
  fileList = [],
  actionPermissions,
  filterList,
  idPage,
}) => {
  const { user } = useAuth();
  const theme = useTheme();
  const { t } = useTranslation("teachers-area-my-classes-page");
  const { filters, setFilters } = useFilters();
  const filterId = `${user?.id_user}_${idPage}`;

  const [showFilter, setShowFilter] = useState(true);

  return (
    <Box
      sx={{
        background: theme.palette.background.default,
        border: "1px solid",
        borderColor: theme.palette.divider,
        boxShadow: "11px 32px 63px rgba(0, 0, 0, 0.1)",
      }}
    >
      {filterList && (
        <Collapse in={showFilter}>
          <LibraryFilterBox
            id="teachers-classes"
            columns={filterList}
            //onChangeFilter={handleChangeFilters}
            keyLang={"teachers-area-my-classes-page"}
          />
        </Collapse>
      )}

      <Box sx={{ p: "24px" }}>
        <Box
          sx={{
            marginBottom: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h4" component={"h3"}>
            {""}
          </Typography>
          <Box>
            {filterList && (
              <ButtonCst
                id="filter"
                onClick={() => setShowFilter(!showFilter)}
                sx={{
                  backgroundColor: "transparent",
                  color: theme.palette.text.primary,
                  padding: 0,
                  minWidth: "40px",
                }}
              >
                <Tooltip title={t("filters")}>
                  {showFilter === true ? (
                    <FilterListOff />
                  ) : (
                    <FilterListOutlined />
                  )}
                </Tooltip>
              </ButtonCst>
            )}
          </Box>
        </Box>
        {fileList?.output && fileList?.output.length > 0 && (
          <Grid container spacing={3}>
            {fileList?.output.map((card: any, index: any) => {
              return (
                card && (
                  <Grid key={index} item xs={12} md={6} xl={4}>
                    <MyClassCardCst
                      classroom_id={card?.id_lo}
                      classroom_label={card?.label_lo}
                      edition_code={card?.edition_code}
                      edition_id={card?.edition_id}
                      teacherName={card?.faculty}
                      image={card.image}
                    />
                  </Grid>
                )
              );
            })}
          </Grid>
        )}
        {
          <Pagination
            count={fileList?.metadata?.total_pages}
            shape="rounded"
            page={(filters[filterId]?.pageIndex || 0) + 1}
            onChange={(e, value) => {
              const newFilters = filters[filterId]
                ? {
                    ...filters[filterId],
                    ...{ pageIndex: value - 1, pageSize: 16 },
                  }
                : { pageIndex: value - 1, pageSize: 16 };

              setFilters(filterId, newFilters);
            }}
          />
        }
      </Box>
    </Box>
  );
};

export default MyClassListBoxCst;
